<div class="card">
  <div class="card-body">
    <h5>{{ "QUẢN LÝ ZNS NHẮC GIA HẠN" | translate }}</h5>
    <div class="row mb-3">
      <!-- Charts -->
      <div class="col-12 col-lg-6">
        <div class="row">
          <div class="col-12 col-sm-6" *ngIf="chartOptions?.series">
            <div class="card mb-0 h-100">
              <div class="card-header">
                <strong>Thống kê trạng thái gửi ZNS</strong>
              </div>
              <div class="card-body d-flex justify-content-center align-items-center">
                <apx-chart
                  [series]="chartOptions.series"
                  [chart]="chartOptions.chart"
                  [labels]="chartOptions.labels"
                  [colors]="chartOptions.colors"
                  [legend]="chartOptions.legend"
                  [dataLabels]="chartOptions.dataLabels"
                  [plotOptions]="chartOptions.plotOptions"
                ></apx-chart>
              </div>
            </div>
          </div>

          <div class="col-12 col-sm-6" *ngIf="deviceChartOptions?.series">
            <div class="card mb-0 h-100">
              <div class="card-header">
                <strong>Thống kê trạng thái loa</strong>
              </div>
              <div class="card-body d-flex justify-content-center align-items-center">
                <apx-chart
                  [series]="deviceChartOptions.series"
                  [chart]="deviceChartOptions.chart"
                  [labels]="deviceChartOptions.labels"
                  [colors]="deviceChartOptions.colors"
                  [legend]="deviceChartOptions.legend"
                  [dataLabels]="deviceChartOptions.dataLabels"
                  [plotOptions]="deviceChartOptions.plotOptions"
                ></apx-chart>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Filters -->
      <div class="col-12 col-lg-6 mt-3 mt-lg-0">
        <div class="row">
          <div class="col-6">
            <div class="form-group">
              <label>{{ "Chọn trạng thái gửi ZNS" | translate }}</label>
              <ng-select [(ngModel)]="filter.status" [clearable]="true">
                <ng-option *ngFor="let item of listStatus" [value]="item.value">
                  {{ item.label }}
                </ng-option>
              </ng-select>
            </div>
          </div>
          <div class="col-6">
            <div class="form-group">
              <label>{{ "Số tài khoản" | translate }}</label>
              <input
                type="tel"
                class="form-control"
                [(ngModel)]="filter.acc_number"
                placeholder="Nhập số tài khoản"
              />
            </div>
          </div>
          <div class="col-6">
            <div class="form-group">
              <label>{{ "Số điện thoại" | translate }}</label>
              <input
                type="tel"
                class="form-control"
                [(ngModel)]="filter.phone"
                placeholder="Nhập số điện thoại"
              />
            </div>
          </div>
          <div class="col-6">
            <div class="form-group">
              <label>{{ "Thời gian lần cuối gửi" | translate }}</label>
              <ng-select [(ngModel)]="filter.dayRange" [clearable]="true">
                <ng-option value="" hidden>
                  {{ "Chọn thời gian lần cuối gửi tin nhắn" | translate }}
                </ng-option>
                <ng-option *ngFor="let item of listDayRange" [value]="item.value">
                  {{ item.label }}
                </ng-option>
              </ng-select>
            </div>
          </div>
          <div class="col-6">
            <div class="form-group">
              <label>{{ "Số lần gửi" | translate }}</label>
              <input
                type="tel"
                class="form-control"
                [(ngModel)]="filter.send_count"
                placeholder="Nhập số lần gửi"
              />
            </div>
          </div>
          <div class="col-6">
            <div class="form-group">
              <label>{{ "SĐT người nhận" | translate }}</label>
              <input
                type="tel"
                class="form-control"
                [(ngModel)]="filter.recipientPhone"
                placeholder="Nhập SĐT người nhận"
              />
            </div>
          </div>
          <div class="col-6">
            <div class="form-group">
              <label>{{ "Trạng thái loa" | translate }}</label>
              <ng-select [(ngModel)]="filter.device_active_status" [clearable]="true">
                <ng-option *ngFor="let item of listDeviceActiveStatus" [value]="item.value">
                  {{ item.label }}
                </ng-option>
              </ng-select>
            </div>
          </div>
          <div class="col-12 text-center mt-2">
            <div class="form-group">
              <button class="btn btn-primary" (click)="submitFilter()">
                {{ "PAGE.REPORT.Search" | translate }}
              </button>
              <button
                class="btn btn-dark ml-2"
                *ngIf="searching"
                (click)="clearFilter()"
              >
                {{ "FORM.Clear" | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="mb-3">
      <button
        class="btn p-2 btn-outline-success"
        (click)="openModal(contentSentMess)"
      >
        Gửi tin tới khách hàng
      </button>
    </div>
    <div class="table-responsive">
      <table
        id="basic-datatable"
        class="table table-bordered dt-responsive zns-table"
      >
        <colgroup>
          <col style="width: 50px" />
          <col style="width: 120px" />
          <col style="width: 160px" />
          <col style="width: 140px" />
          <col style="width: 100px" />
          <col style="width: 160px" />
          <col style="width: 60px" />
          <col style="width: 100px" />
          <col style="width: 120px" />
          <col style="width: 80px" *ngIf="role !== 'operation'" />
        </colgroup>
        <thead>
          <tr class="bg-table">
            <th>#</th>
            <th>{{ "Số tài khoản" | translate }}</th>
            <th>{{ "Thông tin khách hàng" | translate }}</th>
            <th>{{ "Thông tin người nhận" | translate }}</th>
            <th>{{ "Trạng thái gửi ZNS" | translate }}</th>
            <th>{{ "Lỗi gửi ZNS" | translate }}</th>
            <th>{{ "Lần gửi" | translate }}</th>
            <th>{{ "Ngày hết hạn" | translate }}</th>
            <th>{{ "Thông tin gói DV" | translate }}</th>
            <th *ngIf="role !== 'operation'">
              {{ "Quản lý" | translate }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of listData; let i = index">
            <td class="table-column text-center">
              {{ pageSize * (pageIndex - 1) + i + 1 }}
            </td>
            <td class="table-column">{{ data.acc_number }}</td>
            <td
              class="table-column"
              [ngClass]="{ 'zns-sent-highlight': data.last_sent_phone_type === 'USER' }"
            >
              <div>{{ data.user_phone }}</div>
              <div>{{ data.full_name }}</div>
            </td>
            <td
              class="table-column"
              [ngClass]="{ 'zns-sent-highlight': data.last_sent_phone_type === 'RECEIVER' }"
            >
              <div>{{ data.receiver_phone }}</div>
              <div>{{ data.receiver_name }}</div>
            </td>
            <td class="table-column">
              <div>
                <span
                  class="badge font-size-12"
                  [ngClass]="{
                    'badge-secondary': data.status === 'NOT_SENT',
                    'badge-success': data.status === 'SENT',
                    'badge-danger': data.status === 'SENT_FAIL'
                  }"
                >
                  {{ getStatusLabel(data.status) }}
                </span>
              </div>
              <div class="mt-1" *ngIf="data.send_date">
                {{ data.send_date | date : "dd/MM/yyyy HH:mm" }}
              </div>
            </td>
            <td class="table-column">{{ data?.last_error }}</td>
            <td class="table-column">{{ data.send_count || 0 }} lần</td>
            <td class="table-column">
              <div>
                <span
                  class="badge font-size-12"
                  [ngClass]="data.expire_in_days == 0 ? 'badge-danger' : 'badge-secondary'"
                >
                  Còn {{ data.expire_in_days }} ngày
                </span>
              </div>
              <div class="mt-1">
                {{ data.expiration_date | date : "dd/MM/yyyy" }}
              </div>
            </td>
            <td class="table-column">
              <div>
                <span class="badge badge-primary font-size-12">
                  {{ data.packages?.devices[0]?.device_type_name }} x
                  {{ data.packages?.devices.length }}
                </span>
              </div>
              <div class="mt-1">
                {{ data.packages?.devices[0]?.service_package }} tháng
              </div>
            </td>
            <td class="py-2 table-column" *ngIf="role !== 'operation'">
              <div class="d-flex" style="gap: 5px">
                <a
                  class="font-size-18 text-success"
                  ngbTooltip="{{ 'Gửi tin nhắn' | translate }}"
                  placement="left"
                  (click)="sentMess(data)"
                >
                  <i class="ri-mail-send-fill"></i>
                </a>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="row justify-content-md-between align-items-md-center mt-2">
      <div class="col-sm-12 col-md-5">
        <div
          class="dataTables_info mb-2"
          id="tickets-table_info"
          role="status"
          aria-live="polite"
        >
          {{ "TABLE.Showing" | translate }}
          {{ pageSize * pageIndex - pageSize + 1 }}
          {{ "TABLE.to" | translate }} {{ pageSize * pageIndex }}
          {{ "TABLE.of" | translate }} {{ totalCount }}
          {{ "TABLE.entries" | translate }}
        </div>
      </div>
      <!-- Pagination -->
      <div
        class="col-sm-12 col-md-5 d-flex align-items-center justify-content-end"
      >
        <div class="text-md-right float-md-right pagination-rounded">
          <ngb-pagination
            [collectionSize]="totalCount"
            [(page)]="pageIndex"
            [pageSize]="pageSize"
            [maxSize]="5"
            [ellipses]="true"
            (pageChange)="fetchData()"
          >
          </ngb-pagination>
        </div>
        <div class="dataTables_length ml-3" id="tickets-table_length">
          <label class="d-inline-flex align-items-center mb-0">
            {{ "TABLE.Show" | translate }}
            <select
              name="tickets-table_length"
              aria-controls="tickets-table"
              name="pageSize"
              [(ngModel)]="pageSize"
              (ngModelChange)="pageIndex = 1; fetchData()"
              class="custom-select custom-select-sm form-control form-control-sm mx-2"
            >
              <option [ngValue]="10">10</option>
              <option [ngValue]="25">25</option>
              <option [ngValue]="50">50</option>
              <option [ngValue]="100">100</option>
            </select>
            {{ "TABLE.entries" | translate }}
          </label>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #content role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">
      {{ (formData.value.id ? "FORM.Edit" : "FORM.AddNew") | translate }}
    </h5>
    <!-- <div *ngIf="makeForm('password').hasError('required')" class="error-message">
                Mật khẩu không được bỏ trống.
            </div> -->
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <div class="text-left">
      <form (ngSubmit)="saveData()" [formGroup]="formData">
        <div class="row">
          <!-- <div class="form-group row col-md-6">
                            <label class="col-md-2 col-form-label required_label">{{'Imei' | translate}}</label>
                            <div class="col-md-10">
                                <input type="text" class="form-control" formControlName="imei"
                                    [ngClass]="{'is-invalid': submitted && form.imei.errors}" />
                              
                            </div>
                        </div> -->
          <!-- <div class="form-group row col-md-12" *ngIf="!formData.value.id"> -->

          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label">{{
              "Serial" | translate
            }}</label>
            <div class="col-md-10">
              <input
                type="text"
                class="form-control"
                formControlName="serial_number"
                [ngClass]="{
                  'is-invalid': submitted && form.serial_number.errors
                }"
              />
            </div>
          </div>
          <div class="form-group row col-md-12">
            <label class="col-md col-form-label required_label">{{
              "Model" | translate
            }}</label>
            <div class="col-md-10">
              <select
                class="form-select"
                aria-label="Default select example"
                class="form-control"
                formControlName="model"
                [ngClass]="{ 'is-invalid': submitted && form.model.errors }"
              >
                <option value="{{ item }}" *ngFor="let item of listModel">
                  {{ item }}
                </option>
              </select>
              <!-- <input type="text" class="form-control" formControlName="model"
                                    [ngClass]="{'is-invalid': submitted && form.model.errors}" />
                               -->
            </div>
          </div>

          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label">{{
              "Phiên bản" | translate
            }}</label>
            <div class="col-md-10">
              <select
                class="form-select"
                aria-label="Default select example"
                class="form-control"
                formControlName="version"
                [ngClass]="{ 'is-invalid': submitted && form.version.errors }"
              >
                <option value="{{ item }}" *ngFor="let item of listVersion">
                  {{ item }}
                </option>
              </select>
            </div>
          </div>
          <!-- <div class="form-group row col-md-12">
                            <label class="col-md-2 col-form-label required_label">{{'Trạng thái' | translate}}</label>
                            <div class="col-md-10">
                                <select class="form-select" aria-label="Default select example" class="form-control" formControlName="status"  [ngClass]="{'is-invalid': submitted && form.status.errors}">
                                    <option value="0" >Ngoại tuyến</option>
                                    <option value="1" >Trực tuyến</option>
                                </select>
                            </div>
                        </div>   -->
        </div>

        <div class="text-center">
          <button
            type="button"
            class="btn btn-secondary btn-lg mr-3"
            style="width: 150px"
            (click)="modal('close click')"
          >
            {{ "Đóng" | translate }}
          </button>
          <button
            type="submit"
            class="btn btn-success btn-lg"
            style="width: 150px"
          >
            {{ "Lưu" | translate }}
          </button>
          <!-- <button type="button" class="btn btn-secondary btn-sm" style="width: 150px"
                        (click)="modal('close click')">{{'FORM.Close' | translate}}</button>
                    <button type="button" class="btn btn-primary btn-sm ml-3" style="width: 150px"
                        (click)="updateFormNote()">{{'FORM.Save' | translate}}</button> -->
        </div>
      </form>
    </div>
  </div>
</ng-template>

<ng-template #contentSentMess role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">Gửi tin nhắn tới khách hàng</h5>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <div class="text-left">
      <form (ngSubmit)="sendToUsers(formData.value)" [formGroup]="formData">
        <div class="row">
          <div class="form-group row col-md-12">
            <label class="col-md-12 col-form-label required_label">
              {{ "Số lượng khách hàng gửi" | translate }}
              <span class="text-muted">(1 - 500)</span>
            </label>
            <div>
              <div
                class="text-danger"
                *ngIf="formData.controls.data.errors?.min"
              >
                Giá trị phải không nhỏ hơn 1.
              </div>
              <div
                class="text-danger"
                *ngIf="formData.controls.data.errors?.max"
              >
                Giá trị phải không lớn hơn 500.
              </div>
            </div>
            <div class="col-md-12">
              <input
                type="number"
                class="form-control"
                formControlName="data"
                min="1"
                max="500"
                (keydown)="preventNegative($event)"
                [ngClass]="{
                  'is-invalid': submitted && formData.controls.data.invalid
                }"
              />
            </div>
          </div>
        </div>

        <div class="text-center">
          <button
            type="button"
            class="btn btn-secondary btn-lg mr-3"
            style="width: 150px"
            (click)="modal('close click')"
          >
            {{ "Đóng" | translate }}
          </button>
          <button
            type="submit"
            class="btn btn-success btn-lg"
            style="width: 150px"
            [disabled]="formData.controls.data.invalid"
          >
            {{ "Gửi" | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>
</ng-template>
